export default {
  pageListReport: state => state.pageListReport,
  rangeReportListState: state => state.rangeReport.list,
  rangeReportListOptionsState: state => state.rangeReport.listOptions,
  detailReportState: state => state.detailReport,
  autoReportSelectedAccount: state => state.autoReport.selected_account
}
